
import Main 				from './src/main';

$(document).ready( ()=>{

	/*
	// 4 different web stream for each language, same property G$ in ANALYTHICS
	const GA_MEASUREMENT_ID 	= {
		'en' : 'GT-W6J4BK5', //'G-SW715Y7L3B',
		'es' : 'GT-NGJFTP7', //'G-XSZBTT215Y',
		'fr' : 'GT-P3N6CCD', //'G-QG1F21M9BK',
		'ar' : 'GT-PH3TVFQ', //'G-632DE39KRB'		
	},

	CURRENT_MEASUREMENT_ID = GA_MEASUREMENT_ID[ $('html').attr( 'lang' ) ],

	*/

	const CURRENT_MEASUREMENT_ID 	= 'G-8Y28GN49S0',

	LANG 							= $('html').attr( 'lang' ),

	// check if it's loaded inside an iframe -- GIVEWP iframed forms.
	is_not_loaded_inside_iframe 	=  window.location === window.parent.location,

	app = new Main({
		is_ajax 					: is_not_loaded_inside_iframe,
		use_prefetch                : false,
		debug						: true,
		slide_transition			: true,
		time_fade_in 				: 1,
		time_fade_out 				: 0.27,
		
		ease_fade_in 				: 'circ.out',
		ease_fade_out       		: 'circ.out',
		include_footer_transition	: false,

		scrollSmooth 				: false, //is_not_loaded_inside_iframe,

		project_name				: 'ESCR-Net',
		GA_MEASUREMENT_ID 			: CURRENT_MEASUREMENT_ID,
		LANG 						: LANG,
					
		redirects			: [
			 ['/about/', '/about/mission/']
		]
	});

	// INIT !!!
	app.init();

	//console.log( 'app init, CURRENT_MEASUREMENT_ID =' + CURRENT_MEASUREMENT_ID );
});
